<template>
    <div id="vehicle_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehicleHeader" v-if="$route.params.id > 0">Update Asset Feature for {{unitNo}}</span>
                    <span class="page-title" id="vehicleHeader" v-else>Add Asset Feature</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehicleList" >
                        <i class="fp-back"> </i>    Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="VehicleFeatureForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <template v-for="(feature, index) in featureArr">
                                        <div class="col form-group" :key="index">
                                            <label class="control-label" for="feature">{{feature.text}} :</label>
                                            <input type="text" class="form-control" v-model="feature.value" name="name" placeholder="Enter value"/>
                                            <!-- <template v-if="feature.code == 'ltc'">
                                                <date-picker placeholder="MM/DD/YYYY" :name="feature.code" v-model="feature.value" :config="options"></date-picker>
                                            </template>
                                            <template v-else>
                                                <input type="text" class="form-control" v-model="feature.value" name="name" placeholder="Enter value"/>
                                            </template> -->
                                            
                                        </div>
                                    </template>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createVehicleBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateVehicleExtraFeature">
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="cancelVehicleBtn" class="btn btn-tertiary" v-on:click.prevent="BackVehicleList" >
                                        <i class="fp-cancel"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { store } from "../store/extraFeaturesStore.js";
    import {commonMixins} from '../mixins/commonMixins';
    
    export default {
        name: "AssetExtraFeatureCreate",
        mixins:[commonMixins],
        data() {
            return {
                featureArr:[],
                cantAccessPage:'',
                permissions: [],
                loading:false,
                assetId:"",
                assetFeature:[],
                unitNo:"",
                options: {
                    format: 'MM/DD/YYYY',
                    useCurrent: false,
                    toolbarPlacement:'bottom',
                    widgetPositioning: {
                        horizontal: 'auto',
                        vertical: 'bottom'
                    },
                    showClose: true,
                },
            }
        },
        watch: {

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_asset') {
                            self.cantAccessPage = true;
                        }
                    }
                }
            }
        },
        mounted: function() {
            var self = this;
            self.getPermissions();
            var path = window.location.pathname;
            var segments = path.split("/");
            if ( segments[3] ) {
                self.assetId = segments[3];
            }
            self.loadExtraFeatures();
            
        },
        methods: {
            
            BackVehicleList() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                self.$router.push({name: 'AssetView', params: {id: segments[3], selectTab: 20}});
            },

            loadExtraFeatures() {
                
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/asset/extra-feature",
                    type: "GET",
                    data:{
                        assetId:self.assetId,
                        flag:"insert"
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                            self.featureArr = data.feature;
                            self.unitNo = data.unitNo;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'asset-extrafeture-get');

                    }
                });
            },
            CreateVehicleExtraFeature()
            {

                var self = this;
                var fields =[];

                if(self.featureArr.length > 0)
                {
                    fields.push({name:"extra_features",value:JSON.stringify(self.featureArr)});
                }else{
                    fields.push({name:"extra_features",value:''});
                }
                fields.push({name: "id", value: self.assetId});

                $.ajax({
                    url: process.env.ROOT_API + "/asset/create-extra-feature",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if ( self.assetId != "" ) {
                            $("#createVehicleBtn").val("Update");
                            $("#createVehicleBtn").prop("disabled", false);
                            $("#cancelVehicleBtn").prop("disabled", false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#createAndContinueVehicleBtn").val("Save and Continue");
                                $("#createVehicleBtn").prop("disabled", false);
                                $("#createAndContinueVehicleBtn").prop("disabled", false);
                                $("#cancelVehicleBtn").prop("disabled", false);

                            } else {

                                $("#createVehicleBtn").val("Save");
                                $("#createVehicleBtn").prop("disabled", false);
                                $("#createAndContinueVehicleBtn").prop("disabled", false);
                                $("#cancelVehicleBtn").prop("disabled", false);

                            }
                        }
                        if (data.status == "success") {

                            self.$router.push({name: 'AssetView', params: {id: self.assetId, selectTab: 20}});
                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        if ( self.assetId != "" ) {
                            $("#createVehicleBtn").val("Update");
                            $("#createVehicleBtn").prop("disabled", false);
                            $("#cancelVehicleBtn").prop("disabled", false);

                        } else {
                            if (flag == "Save and Continue") {

                                $("#VehicleForm").trigger("reset");


                                $("#createAndContinueVehicleBtn").val("Save and Continue");
                                $("#createVehicleBtn").prop("disabled", false);
                                $("#createAndContinueVehicleBtn").prop("disabled", false);
                                $("#cancelVehicleBtn").prop("disabled", false);

                            } else {

                                $("#createVehicleBtn").val("Save");
                                $("#createVehicleBtn").prop("disabled", false);
                                $("#createAndContinueVehicleBtn").prop("disabled", false);
                                $("#cancelVehicleBtn").prop("disabled", false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,false,'asset-extrafeture-create')
                    }
                });

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/AssetExtraFeatureCreate.vue